<script lang="ts">
	import { page } from '$app/stores';
	import { consentVendorsStore } from '../stores/consent';
	import { listenToVendorConsent } from '../utils/didomi';
	import { datadogClientLogs, didomi, googleTagManager } from '@app/utils/third-party-scripts';
	import { onMount } from 'svelte';
	import { datadogRum } from '@datadog/browser-rum';
	import {
		PUBLIC_IS_STAGING,
		PUBLIC_PREPROD_GTM_TOKEN,
		PUBLIC_PROD_GTM_TOKEN
	} from '$env/static/public';
	import { dev } from '$app/environment';

	let isLinkedinConsent: boolean;

	const initThirdPartyScripts = () => {
		didomi();
		googleTagManager();
		if (!dev) {
			datadogClientLogs();
		}

		window.didomiOnReady = window.didomiOnReady || [];
		window.didomiOnReady.push(function (Didomi) {
			let requiredVendorsArray = Didomi.getRequiredVendors();
			let requiredVendors = {};

			requiredVendorsArray.forEach((v) => {
				requiredVendors[v.id] = {
					name: v.name ? v.name : 'Dailymotion SA',
					consent: undefined
				};
			});

			consentVendorsStore.set(requiredVendors);

			requiredVendorsArray.forEach((v) => {
				listenToVendorConsent(v.id);
			});
		});
	};

	onMount(() => {
		initThirdPartyScripts();
		if ($page.data.user) {
			datadogRum.setGlobalContextProperty('userId', $page.data.user?.id);
		}
	});

	$: if ($consentVendorsStore['c:linkedin']) {
		isLinkedinConsent = $consentVendorsStore['c:linkedin'].consent;
	}
</script>

<svelte:head>
	<noscript>
		<iframe
			src="//www.googletagmanager.com/ns.html?id=${PUBLIC_IS_STAGING === 'true'
				? PUBLIC_PREPROD_GTM_TOKEN
				: PUBLIC_PROD_GTM_TOKEN}"
			height="0"
			width="0"
			style="display:none;visibility:hidden"
		/>
	</noscript>
</svelte:head>

{#if isLinkedinConsent}
	<img
		height="1"
		width="1"
		style="display:none;"
		alt=""
		src="https://px.ads.linkedin.com/collect/?pid=2888530&conversionId=4923065&fmt=gif"
	/>
{/if}
